var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sourcing-audit" },
    [
      _c("div", [
        _c("p", {
          staticClass: "closeBtn icon-guanbi",
          on: { click: _vm.closePage },
        }),
      ]),
      _c(
        "el-form",
        {
          staticClass: "form_border",
          attrs: {
            model: _vm.sourcingLineHeadInfo,
            "label-position": _vm.labelPosition,
            "label-width": "130px",
            disabled: true,
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("quoteByLine.sourcing.sourcingNo"),
                        prop: "sourcingNo",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "handle-input",
                        staticStyle: { width: "100%" },
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.sourcingLineHeadInfo.sourcingNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.sourcingLineHeadInfo,
                              "sourcingNo",
                              $$v
                            )
                          },
                          expression: "sourcingLineHeadInfo.sourcingNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.sourcingLineHeadInfo.sourcingCategory == "PRODUCT"
                            ? _vm.$t("quote.applyNo")
                            : _vm.$t("quoteByLine.sourcing.applyNo"),
                        prop: "applyNo",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "handle-input",
                        staticStyle: { width: "100%" },
                        attrs: { clearable: "" },
                        model: {
                          value:
                            _vm.sourcingLineHeadInfo.auotationApply.applyNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.sourcingLineHeadInfo.auotationApply,
                              "applyNo",
                              $$v
                            )
                          },
                          expression:
                            "sourcingLineHeadInfo.auotationApply.applyNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("quoteByLine.sourcing.subject"),
                        prop: "subject",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "handle-input",
                        staticStyle: { width: "100%" },
                        attrs: { clearable: "" },
                        model: {
                          value:
                            _vm.sourcingLineHeadInfo.auotationApply.subject,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.sourcingLineHeadInfo.auotationApply,
                              "subject",
                              $$v
                            )
                          },
                          expression:
                            "sourcingLineHeadInfo.auotationApply.subject",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("common.createDate"),
                        prop: "createDate",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "handle-input",
                        staticStyle: { width: "100%" },
                        attrs: {
                          value: _vm._f("dateFormatFilter")(
                            _vm.sourcingLineHeadInfo.createDate,
                            "YYYY-MM-DD"
                          ),
                          clearable: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("common.createBy"),
                        prop: "createBy",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "handle-input",
                        staticStyle: { width: "100%" },
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.sourcingLineHeadInfo.creater,
                          callback: function ($$v) {
                            _vm.$set(_vm.sourcingLineHeadInfo, "creater", $$v)
                          },
                          expression: "sourcingLineHeadInfo.creater",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("common.rounds"),
                        prop: "roundNumber",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "handle-input",
                        staticStyle: { width: "100%" },
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.sourcingLineHeadInfo.roundNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.sourcingLineHeadInfo,
                              "roundNumber",
                              $$v
                            )
                          },
                          expression: "sourcingLineHeadInfo.roundNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "报价确认明细", name: "detail" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form",
                    {
                      ref: "queryCondition",
                      staticClass: "searchForm",
                      attrs: {
                        model: _vm.queryCondition,
                        "label-position": "right",
                        "label-width": "120px",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "8位码",
                                    prop: "eightBitCode",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "handle-input",
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.eightBitCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "eightBitCode",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.eightBitCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "8位码名称",
                                    prop: "eightBitCodeName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "handle-input",
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value:
                                        _vm.queryCondition.eightBitCodeName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "eightBitCodeName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryCondition.eightBitCodeName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "非标准线路运费",
                                    prop: "isSpecialFreight",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "handle-input",
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value:
                                          _vm.queryCondition.isSpecialFreight,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "isSpecialFreight",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.isSpecialFreight",
                                      },
                                    },
                                    _vm._l(
                                      _vm.isSpecialFreightList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.label,
                                            value: item.key,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "审核状态", prop: "status" },
                                },
                                [
                                  _c("ic-select", {
                                    staticClass: "handle-input",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      table: "TT_SOURCING",
                                      field: "STATUS",
                                    },
                                    model: {
                                      value: _vm.queryCondition.status,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "status",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        {
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { type: "flex", justify: "center" },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.onSearch(1)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.search")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.reset")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.sourcingLine.filter((line) => {
                          return line.canAudit
                        }).length > 0,
                      expression:
                        "sourcingLine.filter(line=>{return line.canAudit}).length>0",
                    },
                  ],
                  staticClass: "action-btn-row",
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.audit("PASS")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.pass")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "danger" },
                      on: {
                        click: function ($event) {
                          return _vm.audit("REJECT")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.reject")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "danger" },
                      on: {
                        click: function ($event) {
                          return _vm.audit("STOP")
                        },
                      },
                    },
                    [_vm._v("终止")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onDownload },
                    },
                    [_vm._v("下载")]
                  ),
                ],
                1
              ),
              _vm.sourcingLineHeadInfo.sourcingCategory == "PRODUCT"
                ? _c(
                    "ux-grid",
                    {
                      ref: "pxTable",
                      attrs: {
                        data: _vm.sourcingLine,
                        checkboxConfig: {
                          checkMethod: _vm.selectable,
                          highlight: true,
                        },
                        "keep-source": "",
                        "max-height": "550",
                        "show-overflow": "tooltip",
                      },
                      on: {
                        "sort-change": _vm.sortChange,
                        "selection-change": _vm.changeSelect,
                      },
                    },
                    [
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          type: "checkbox",
                          width: "80",
                          fixed: "left",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          field: "itemSequence",
                          title: _vm.$t("quoteByLine.sourcing.itemNo"),
                          "min-width": "90",
                          resizable: "",
                          align: "center",
                          sortable: "",
                          fixed: "left",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          field: "tmSupplierId",
                          title: _vm.$t("quoteByLine.sourcing.finalSupplier"),
                          "min-width": "120",
                          resizable: "",
                          align: "center",
                          sortable: "",
                          fixed: "left",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("ic")(
                                          scope.row.tmSupplierId,
                                          "BASE",
                                          "CARRIER"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3523784327
                        ),
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          field: "eightBitCode",
                          title: "8位码",
                          "min-width": "90",
                          resizable: "",
                          align: "center",
                          sortable: "",
                          fixed: "left",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          field: "eightBitCodeName",
                          title: "8位码名称",
                          "min-width": "200px",
                          resizable: "",
                          align: "center",
                          sortable: "",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          field: "pickupPoint",
                          title: "提货点",
                          "min-width": "90",
                          resizable: "",
                          align: "center",
                          sortable: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("ic")(
                                          scope.row.tmPickupId,
                                          "BASE",
                                          "PICKUP_POINT"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4079354812
                        ),
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          field: "dcName",
                          title: "到货仓库",
                          "min-width": "100",
                          resizable: "",
                          align: "center",
                          sortable: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("ic")(
                                          scope.row.tmDcId,
                                          "BASE",
                                          "DC"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          97485839
                        ),
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          field: "linePrice",
                          title: "线路价格",
                          "min-width": "100",
                          resizable: "",
                          align: "center",
                          sortable: "",
                        },
                      }),
                      _vm.showProductInfo
                        ? _c("ux-table-column", {
                            attrs: {
                              field: "isSpecialFreight",
                              title: "非标准线路运费",
                              "min-width": "150",
                              resizable: "",
                              align: "center",
                              sortable: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("ic")(
                                              scope.row.isSpecialFreight,
                                              "COMMON",
                                              "YES_NO"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1576990922
                            ),
                          })
                        : _vm._e(),
                      _vm.showProductInfo
                        ? _c("ux-table-column", {
                            attrs: {
                              field: "productPrice",
                              title: "产品运费（不含税）",
                              "min-width": "170",
                              resizable: "",
                              align: "center",
                              sortable: "",
                            },
                          })
                        : _vm._e(),
                      _c("ux-table-column", {
                        attrs: {
                          field: "currentProductPrice",
                          title: "现有产品价格",
                          "min-width": "140",
                          resizable: "",
                          align: "center",
                          sortable: "",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          field: "changeRate",
                          title: "价格变化",
                          "min-width": "100",
                          resizable: "",
                          align: "center",
                          sortable: "",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          field: "tcCurrencyId",
                          title: "币种",
                          "min-width": "80",
                          resizable: "",
                          align: "center",
                          sortable: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("ic")(
                                          scope.row.tcCurrencyId,
                                          "BASE",
                                          "CURRENCY_ID"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3007509715
                        ),
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          field: "remarks",
                          title: _vm.$t("common.remarks"),
                          "min-width": "120",
                          resizable: "",
                          align: "center",
                          sortable: "",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          field: "temperatureI18n",
                          title: "温区",
                          "min-width": "80",
                          resizable: "",
                          align: "center",
                          sortable: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("ic")(
                                          scope.row.temperature,
                                          "COMMON",
                                          "TEMPERATURE"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          636025187
                        ),
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          field: "transportaionMethod",
                          title: "运输方式",
                          "min-width": "100",
                          resizable: "",
                          align: "center",
                          sortable: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("ic")(
                                          scope.row.transportaionMethod,
                                          "COMMON",
                                          "TRANSPORTAION_METHOD"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2580796764
                        ),
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          field: "unitI18n",
                          title: "结算单位",
                          "min-width": "100",
                          resizable: "",
                          align: "center",
                          sortable: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("ic")(
                                          scope.row.lineUnit,
                                          "COMMON",
                                          "UNIT"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3133672685
                        ),
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          field: "effectiveBeginDate",
                          title: "有效开始日期",
                          "min-width": "140",
                          resizable: "",
                          align: "center",
                          sortable: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("dateFormatFilter")(
                                          scope.row.effectiveBeginDate,
                                          "YYYY-MM-DD"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1544433441
                        ),
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          field: "status",
                          title: _vm.$t("common.status"),
                          "min-width": "80",
                          resizable: "",
                          align: "center",
                          sortable: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("ic")(
                                          scope.row.status,
                                          "TT_SOURCING",
                                          "STATUS"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2760127849
                        ),
                      }),
                      _vm.showProductInfo
                        ? _c("ux-table-column", {
                            attrs: {
                              field: "externalPackagingLength",
                              title: "外包装长(cm)",
                              "min-width": "140",
                              resizable: "",
                              align: "center",
                              sortable: "",
                            },
                          })
                        : _vm._e(),
                      _vm.showProductInfo
                        ? _c("ux-table-column", {
                            attrs: {
                              field: "externalPackagingWidth",
                              title: "外包装宽(cm)",
                              "min-width": "140",
                              resizable: "",
                              align: "center",
                              sortable: "",
                            },
                          })
                        : _vm._e(),
                      _vm.showProductInfo
                        ? _c("ux-table-column", {
                            attrs: {
                              field: "externalPackagingHeight",
                              title: "外包装高(cm)",
                              "min-width": "140",
                              resizable: "",
                              align: "center",
                              sortable: "",
                            },
                          })
                        : _vm._e(),
                      _vm.showProductInfo
                        ? _c("ux-table-column", {
                            attrs: {
                              field: "externalPackagingNetweight",
                              title: "外包装净重(kg)",
                              "min-width": "150",
                              resizable: "",
                              align: "center",
                              sortable: "",
                            },
                          })
                        : _vm._e(),
                      _vm.showProductInfo
                        ? _c("ux-table-column", {
                            attrs: {
                              field: "externalPackagingGrossweight",
                              title: "外包装毛重(kg)",
                              "min-width": "150",
                              resizable: "",
                              align: "center",
                              sortable: "",
                            },
                          })
                        : _vm._e(),
                      _vm.showProductInfo
                        ? _c("ux-table-column", {
                            attrs: {
                              field: "palletLayerNumber",
                              title: "每Pallet层数",
                              "min-width": "140",
                              resizable: "",
                              align: "center",
                              sortable: "",
                            },
                          })
                        : _vm._e(),
                      _vm.showProductInfo
                        ? _c("ux-table-column", {
                            attrs: {
                              field: "palletLayerBoxNumber",
                              title: "每层箱数",
                              "min-width": "120",
                              resizable: "",
                              align: "center",
                              sortable: "",
                            },
                          })
                        : _vm._e(),
                      _vm.showProductInfo
                        ? _c("ux-table-column", {
                            attrs: {
                              field: "palletItemsLength",
                              title: "托盘上物品长度(cm)",
                              "min-width": "190",
                              resizable: "",
                              align: "center",
                              sortable: "",
                            },
                          })
                        : _vm._e(),
                      _vm.showProductInfo
                        ? _c("ux-table-column", {
                            attrs: {
                              field: "palletItemsWidth",
                              title: "托盘上物品宽度(cm)",
                              "min-width": "190",
                              resizable: "",
                              align: "center",
                              sortable: "",
                            },
                          })
                        : _vm._e(),
                      _vm.showProductInfo
                        ? _c("ux-table-column", {
                            attrs: {
                              field: "palletItemsHeight",
                              title: "托盘上物品高度(cm)",
                              "min-width": "190",
                              resizable: "",
                              align: "center",
                              sortable: "",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-dialog",
                {
                  staticClass: "dialog",
                  attrs: {
                    title: "报价确认申请",
                    "append-to-body": "",
                    visible: _vm.auditDialog,
                    width: "1200px",
                  },
                  on: {
                    close: function ($event) {
                      _vm.auditDialog = false
                    },
                  },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      attrs: { model: _vm.auditForm, "label-width": "100px" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "审批意见", prop: "comments" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea" },
                            model: {
                              value: _vm.auditForm.comments,
                              callback: function ($$v) {
                                _vm.$set(_vm.auditForm, "comments", $$v)
                              },
                              expression: "auditForm.comments",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "附件", prop: "files" } },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "upload",
                              staticClass: "upload-demo",
                              attrs: {
                                headers: _vm.header,
                                action: _vm.fileUploadUrl,
                                "on-preview": _vm.handlePreview,
                                "on-success": _vm.uploadSuccess,
                                "on-remove": _vm.onRemoveFile,
                                "before-remove": _vm.beforeRemove,
                                multiple: "",
                                "file-list": _vm.files,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                { attrs: { size: "small", type: "primary" } },
                                [_vm._v("点击上传")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.submit()
                                },
                              },
                            },
                            [_vm._v("确定")]
                          ),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.auditDialog = false
                                },
                              },
                            },
                            [_vm._v("取消")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("common.approvalLog"), name: "log" } },
            [
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: {
                    data: _vm.auditLog,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      sortable: "",
                      prop: "operatorName",
                      align: "center",
                      label: _vm.$t("common.OperatorName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      sortable: "",
                      prop: "createDate",
                      align: "center",
                      label: _vm.$t("common.OperationTime"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFormatFilter")(
                                    scope.row.createDate,
                                    "YYYY-MM-DD HH:mm:ss"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      sortable: "",
                      prop: "action",
                      align: "center",
                      label: _vm.$t("common.PedagogicalOperation"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "",
                      prop: "comments",
                      align: "center",
                      label: _vm.$t("common.note"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      sortable: "",
                      align: "center",
                      label: _vm.$t("common.attachment"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormatFilter")(
                                  scope.row.effectiveBeginDate,
                                  "YYYY-MM-DD HH:mm"
                                )
                              ) + " "
                            ),
                            _c("fileList", {
                              attrs: { files: scope.row.docs },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }